import { useExplorerLink } from '@/composables/core/useExplorerLink';
import { useWallet } from '@/composables/core/useWallet';

const { address } = useWallet();

export function useAddressLink() {
  return useExplorerLink(address);
}
